import React, { useCallback } from 'react';

import { useField } from 'formik';

import { ChoiceGroup, ChoiceGroupProps } from './ChoiceGroup';

export type FormikChoiceGroupProps = Pick<
  ChoiceGroupProps,
  | 'onChange'
  | 'onBlur'
  | 'label'
  | 'choices'
  | 'error'
  | 'multiple'
  | 'name'
  | 'disabled'
>;

export const FormikChoiceGroup: React.FunctionComponent<FormikChoiceGroupProps> = props => {
  const [field, , { setValue }] = useField<string | string[]>(props.name);

  const onChange = useCallback(
    (_, newValue) => {
      setValue(newValue);
    },
    [setValue],
  );

  return (
    <ChoiceGroup
      {...props}
      value={field.value}
      name={field.name}
      onChange={onChange}
    />
  );
};
